<script>
    $(document).ready(function(){
        $('[data-toggle="tooltip"]').tooltip();
    });
</script>
    <div class="main-page">
        <div class="container">
            <div class="table-responsive">
                <div class="table-wrapper mb-5">
                    <div class="table-title">
                        <div class="row">
                            <div class="col-xs-5">
                                <h2>Staff Dashboard</h2>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3 mb-2">
                        <div class="col-3">
                            <label>Waitlist</label>
                            <select (change)="changeSelectedApplicantsByWaitlist($event)" class="form-control col-xs-7">
                                <option *ngFor="let w of waitlists" class="option-label" [value]="w.name">{{w.name}}</option>
                            </select>
                        </div>
                        <div class="col-2 ml-2">
                            <label>Date Selected</label>
                            <select (change)="changeSelectedApplicantsByDateSelected($event)" class="form-control col-xs-7">
                                <option *ngFor="let d of selectedDates" class="option-label" [value]="d">{{d | date:'MM-dd-YYYY'}}</option>
                            </select>
                        </div>
                        <div class="col-6 text-end">
                            <input class="" type="text" name="search" [(ngModel)]="searchText" autocomplete="off" placeholder="search">
                            <span><a href="javascript:void(0)" (click)="search()" class="btn btn-xs btn-search"><i class="fa-solid fa-magnifying-glass"></i></a></span>
                        </div>                        
                    </div>
                    <table class="table table-bordered table-striped table-responsive-stack">
                        <thead class="bg-light text-center">
                            <tr>
                                <th class="bg-table-header">T Code</th>
                                <th class="bg-table-header">Name</th>
                                <!-- <th class="bg-table-header">Address</th>						
                                <th class="bg-table-header">Phone</th>
                                <th class="bg-table-header">Email</th> -->
                                <th class="bg-table-header">Status</th>
                                <th class="bg-table-header">Date Selected</th>
                                <th class="bg-table-header">Preferences</th>
                                <!-- <th class="bg-table-header">Other T Codes</th> -->
                            </tr>
                        </thead>
                        <tbody *ngFor="let a of selectedApplicants | orderby:'dateSelected':false | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems }; 
                            let i = index">
                            <tr>
                                <td class="table-content col-2"><a href="javascript:void(0)" (click)="goToApplicantDashboard(a.pCode)">{{a.pCode}}</a></td>
                                <td class="table-content col-2">{{a.firstName}} {{a.lastName}}</td>
                                <!-- <td class="table-content col-2">{{a.mailingAddress}} {{a.apt}}, {{a.city}}, {{a.state}} {{a.zipCode}}</td>
                                <td class="table-content col-2">{{a.cellTel}}</td>
                                <td class="table-content col-2">{{a.email}}</td> -->
                                <td class="table-content col-2">{{a.tenantStatus}}</td>
                                <td class="table-content col-2">{{a.dateSelected | date:'MM-dd-YYYY' }}</td>
                                <td class="table-content col-5">{{a.preferences}}</td>
                                <!-- <td class="table-content col-2">{{a.otherTCodes}}</td> -->
                            </tr>
                            <tr *ngIf="!selectedApplicants || selectedApplicants.length == 0"><td class="table-content" colspan="9">No items found</td></tr>
                        </tbody>
                    </table>
                    <div class="clearfix">
                        <div class="col-xs-6">
                            <div class="hint-text text-left">A total of <b>{{totalItems}}</b> applicants</div>
                        </div>
                        <div class="col-xs-6 text-right">
                            <div class="page-item"><pagination-controls class="page-link" (pageChange)="pageChangeEvent($event)"></pagination-controls></div>
                        </div>
                    </div>
                </div>
            </div> 
            <ngx-spinner bdcolor="rgba(51,51,51,0.8)" size="default" type="ball-spin-clockwise">
                <p style="color: white;">Please wait.</p>
            </ngx-spinner>             
        </div>
    </div>     
    